import { Fragment } from "react";

/**
 * Lets a name such as "Employee/contractor" wrap after its slashes, which browsers do not treat as
 * a place to break, so a narrow column wraps it between words instead of cutting into one.
 */
export const breakAfterSlashes = (text: string) => {
  const parts = text.split("/");
  return parts.map((part, index) => (
    <Fragment key={index}>
      {part}
      {index < parts.length - 1 && (
        <>
          /<wbr />
        </>
      )}
    </Fragment>
  ));
};
